import { ActivityIndicator, Button, Text } from "../components/generic"
import React, { useState } from "react"
import gql from 'graphql-tag'
import { useQuery } from "react-apollo"
import CreditLifeQuickQuote from "../components/insurance/CreditLifeQuickQuote"
import { navigate } from "gatsby"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import { ThemeProvider } from "emotion-theming"
import { useTheme } from "./sales-sign-in"

const GET_EMPLOYEE_INFO = gql`{
  me {
    id
    first
    last
  }
}`


function SalesPage() {

  const [open, setOpen] = useState(false)
  const { data, loading, error } = useQuery(GET_EMPLOYEE_INFO)

  if (loading) return <ThemeProvider theme={useTheme}><ActivityIndicator /></ThemeProvider>

  if (!data || !data.me) {
    return <Text>Not Authorised</Text>
  }

    return (
      <ThemeProvider theme={useTheme}>
      <Layout noHeader noMoku noFooter>
        <SEO title="Sales" noTemplate />
  
        
        <CreditLifeQuickQuote open={open} setOpen={setOpen} productType="RMA" sales />
          <center>
          <p />
          <p />
          <img style={{ width: 150 }} src={useTheme.logo} alt="logo" />
          <Text size={32} bold>Sales</Text>
          <p />
          <p>
            <Text>Welcome {data.me.first} {data.me.last}</Text>
          </p>
          <p>
            <Button onClick={() => setOpen(true)}>New RMA CLI</Button>
          </p>
          <p />
          <p>
            <Button inverted noBorder onClick={() => navigate('/logout?redirect=/sales-sign-in')}>Logout</Button>
          </p>
          If you need support then please email us on matlasupport@meerkat.co.za or call us on 021 003 4521.
        </center>
        
        </Layout>
        </ThemeProvider>
    )
}


export default SalesPage